import { render, staticRenderFns } from "./postInstagram.vue?vue&type=template&id=e662804e"
import script from "./postInstagram.vue?vue&type=script&lang=js"
export * from "./postInstagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e662804e')) {
      api.createRecord('e662804e', component.options)
    } else {
      api.reload('e662804e', component.options)
    }
    module.hot.accept("./postInstagram.vue?vue&type=template&id=e662804e", function () {
      api.rerender('e662804e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/renderPost/postInstagram.vue"
export default component.exports